import { render, staticRenderFns } from "./StepsHeader.vue?vue&type=template&id=1e4dda42&"
import script from "./StepsHeader.vue?vue&type=script&lang=js&"
export * from "./StepsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e4dda42')) {
      api.createRecord('1e4dda42', component.options)
    } else {
      api.reload('1e4dda42', component.options)
    }
    module.hot.accept("./StepsHeader.vue?vue&type=template&id=1e4dda42&", function () {
      api.rerender('1e4dda42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/allocation/StepsHeader.vue"
export default component.exports